import { Component, NgZone } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { PetRoutingService } from '@app/services/pet-routing.service';
import { SiteService } from '@app/services/site.service';
import { CreateAccountFormComponent } from 'app-classic/components/user-accounts/create-account-form/create-account-form.component';
import { LoginFormComponent } from 'app-classic/components/user-accounts/login-form/login-form.component';
import { ContentService } from 'app-classic/services/content.service';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { EnterYourInformationComponent as NewEnterYourInformationComponent } from '../../../../app/components/booking-steps/enter-your-information/enter-your-information.component';

@Component({
    selector: 'app-enter-your-information',
    templateUrl: './enter-your-information.component.html',
    styleUrls: ['./enter-your-information.component.scss'],
    standalone: false,
})
export class EnterYourInformationComponent extends NewEnterYourInformationComponent {
    constructor(
        private _fb: FormBuilder,
        private _navigationService: NavigationService,
        private _localStorageService: LocalStorageService,
        private _featureFlagService: FeatureFlagService,
        private _userAccountService: UserAccountService,
        private bottomSheet: MatBottomSheet,
        private _contentService: ContentService,
        private _ngZone: NgZone,
        private _siteService: SiteService,
        private _petRoutingService: PetRoutingService
    ) {
        super(
            _fb,
            _navigationService,
            _localStorageService,
            _featureFlagService,
            _userAccountService,
            _contentService,
            _ngZone,
            _siteService,
            _petRoutingService
        );
    }

    public onClickLogIn() {
        this.bottomSheet.open(LoginFormComponent, { disableClose: true });
    }

    public onClickCreateAccount() {
        this.bottomSheet.open(CreateAccountFormComponent, { disableClose: true });
    }
}
